export default __webpack_public_path__ + "static/media/640_dummy2016-coach01-de.0b80e8a2.png";